import * as Data from './archibus-v2/DataApi'
import {fetchRooms} from './room'
import {departmentColors} from '../utils/colors'

export const fetchDepartmentsByDivision = ({dvId = null}) => {
  let restriction = null
  if (dvId) {
    restriction = new Ab.view.Restriction()
    restriction.addClause('dp.dv_id', dvId)
  }

  return Data.getDataFromDataSource(
    'ab-self-service.axvw',
    'departments',
    restriction
  ).then(({data}) => {
    return Promise.resolve(data)
  })
}

export const fetchDepartmentsByFloor = ({blId, flId}) => {
  // Get the rooms by floor
  return fetchRooms({blId, flId}).then(rooms => {
    let deptSet = new Set()
    let colorIdx = 0
    let departments = Object.values(rooms).reduce((acc, curVal) => {
      const {deptCode, dvId, dpId, dpName, dvName} = curVal
      if (!acc[deptCode]) {
        let duplicate = false
        if (deptSet.has(dpName)) {
          duplicate = true

          // Find other objects in the accumulator that have the same department name but that are not duplicates
          // and set the duplicate value
          Object.values(acc)
            .filter(
              item => item.department === dpName && item.duplicate === false
            )
            .forEach(dept => {
              dept.duplicate = true
            })
        } else {
          deptSet.add(dpName)
        }

        acc[deptCode] = {
          dvId,
          dpId,
          department: dpName,
          division: dvName,
          color: departmentColors[colorIdx % departmentColors.length],
          deptCode: dvId + '|' + dpId,
          duplicate,
          name: `${dpName} - ${dvName}`
        }
        colorIdx += 1
      }

      return acc
    }, {})

    let sortedDepartments = Object.values(departments)
      .map(dept => {
        dept.name = dept.duplicate ? dept.name : dept.department
        return dept
      })
      .sort((a, b) => a.department.localeCompare(b.department))

    return Promise.resolve(sortedDepartments)
  })
}
